import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import permissionsReducer from './permissionsReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  customization: customizationReducer,
  permissions: permissionsReducer
});

export default reducer;
